import { QrCodeLinkCreatorService } from 'client/js/main/services/QrCodeLinkCreatorService/QrCodeLinkCreatorService';
import {
  selectIsEditing,
  selectQrCodeLinkCreatorState,
  areQrCodeSettingsEqual,
} from 'client/js/redux/domains/QrCodeLinkCreator/QrCodeLinkCreator.selectors';
import { selectQrCodeSettings } from 'client/js/redux/domains/AppStore';
import dash_api from 'client/js/main/support/dash_api';
import type { DataAction } from 'client/js/redux/types/dataAction.type';
import type { Dispatch, RootState } from 'client/js/redux/types/redux.types';
import { deepCopy } from '../../../../../../shared/utils';

const SUBMIT_QR_CODE_LINK_URL = '/v1/qr-code-link';

export const SUBMIT_QR_CODE_LINK = 'SUBMIT_QR_CODE_LINK' as const;

export const submitQrCodeLink = () => async (_: Dispatch, getState: () => RootState) => {
  const state = getState();
  const qrCodeState = deepCopy(selectQrCodeLinkCreatorState(state));
  const qrCodeSettings = selectQrCodeSettings(state);

  const areQrCodeSettingsUnchanged = areQrCodeSettingsEqual(qrCodeState.qrCodeCustomization, qrCodeSettings);
  if (areQrCodeSettingsUnchanged) {
    qrCodeState.qrCodeCustomization = {};
  }

  const isEditing = selectIsEditing(state);
  const payload = QrCodeLinkCreatorService.getQrCodeLinkPayload(qrCodeState);

  let response;
  if (!isEditing) {
    response = await dash_api.post(SUBMIT_QR_CODE_LINK_URL, payload);
  } else {
    response = await dash_api.put(`${SUBMIT_QR_CODE_LINK_URL}/${qrCodeState.id}`, payload);
  }

  return response?.data;
};

export type SubmitQrCodeLinkAction = DataAction<typeof SUBMIT_QR_CODE_LINK, void>;
